import React from 'react';
import GiftCardVisual from '@/components/GiftCardVisual';

export default function GiftCardThumb({ amount }) {
  return (
    <div className="w-28 sm:w-32 aspect-[3/2] flex-shrink-0 overflow-hidden bg-[#fbf6ef]" aria-label="Forskoðun rafræns gjafabréfs">
      <GiftCardVisual amount={amount} code="" />
    </div>
  );
}